import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function BedIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M 5 4 C 3.895 4 3 4.895 3 6 L 3 11.277344 C 2.4043659 11.623613 2 12.261054 2 13 L 2 22 L 4 22 L 4 20 L 20 20 L 20 22 L 22 22 L 22 13 C 22 12.261054 21.595634 11.623613 21 11.277344 L 21 6 C 21 4.895 20.105 4 19 4 L 5 4 z M 5 6 L 19 6 L 19 11 L 18 11 L 18 9 C 18 8.448 17.552 8 17 8 L 14 8 C 13.448 8 13 8.448 13 9 L 13 11 L 11 11 L 11 9 C 11 8.448 10.552 8 10 8 L 7 8 C 6.448 8 6 8.448 6 9 L 6 11 L 5 11 L 5 6 z M 4 13 L 20 13 L 20 18 L 4 18 L 4 13 z" />
        </SvgIcon>
    );
}
